/* eslint-disable max-lines-per-function */
'use strict';

// eslint-disable-next-line max-params, max-lines-per-function
angular.module('webAgro1App').controller('ParametroCtrl', function($scope, $rootScope, $location,
  $q, $anchorScroll, Flash, ParametrosService, OperacoesService, LoadingService, UnidadesService,
  MessagesService, ContratoService, PrestacaoServicos) {
  const MAX_KBYTES_UPLOAD = 1024;
  const MAX_REGISTROS_ENVIO_PADRAO = 5;
  const MODELOS_RELATORIOS = [
    { id: 'itens', descricao: 'Modelo padrão' },
    { id: 'fotos_separadas', descricao: 'Fotos exibidas depois dos textos' },
    { id: 'padrao_com_tabela', descricao: 'Modelo padrão com tabela' }
  ];

  // eslint-disable-next-line max-lines-per-function
  $scope.init = function() {
    LoadingService.showLoading();

    // eslint-disable-next-line max-lines-per-function
    $rootScope.initialize.then(function() {
      if (!$rootScope.permissions.parametro.canManage) {
        $location.path('/');
        Flash.create(ACESSO_NAO_PERMITIDO.type, ACESSO_NAO_PERMITIDO.msg);
        return;
      }

      $scope.slider = {
        options: {
          showSelectionBar: true,
          floor: 1,
          ceil: 30,
          getSelectionBarColor: function() {
            return 'yellow';
          }
        }
      };

      $q.all([
        ParametrosService.get(),
        OperacoesService.getTipoOperacoesCampo(),
        UnidadesService.all(),
        OperacoesService.getTipoOperacoesCampoParaSemeadura(),
        OperacoesService.getTipoOperacoesCampoParaAdubacao(),
        OperacoesService.getTipoOperacoesCorrecaoDeSolo(),
        ContratoService.get(),
        OperacoesService.getTipoOperacoesCampoParaColheita()
        // eslint-disable-next-line max-lines-per-function
      // eslint-disable-next-line complexity
      ]).then(([
        parametros,
        operacoesCampo,
        unidades,
        operacoesSemeadura,
        operacoesAdubacao,
        operacoesCorrecaoDeSolo,
        contrato,
        operacoesColheita
      ]) => {
        $scope.parametro = parametros.data.parametros || {};
        try {
          $scope.logomarcaUrl = SERVER + parametros.data.imagem.imagem_thumb_url;
        } catch (error) {
          console.error(error);
        }
        $scope.parametro.id = parametros.data.id;
        $scope.operacoes = operacoesCampo.data;
        $scope.unidades = unidades.data;
        $scope.operacoesSemeadura = operacoesSemeadura.data;
        $scope.operacoesAdubacaoBase = operacoesAdubacao.data;
        $scope.operacoesCorrecaoDeSolo = operacoesCorrecaoDeSolo.data;
        $scope.modelosRelatorios = MODELOS_RELATORIOS;
        $scope.operacoesColheita = operacoesColheita.data;
        $scope.operacoesAdubacao = operacoesAdubacao.data.concat(operacoesCorrecaoDeSolo.data);

        if (!$scope.parametro.configuracoesVisita) {
          $scope.parametro.configuracoesVisita = {
            equilibrio: 7,
            controle: 15,
            caminhamento: {}
          };
        }

        if (!$scope.parametro.configuracoesPulverizacao) {
          $scope.parametro.configuracoesPulverizacao = {
            equilibrio: 7,
            controle: 15
          };
        }

        if (!$scope.parametro.percentual_recomendado_aplicado) {
          $scope.parametro.percentual_recomendado_aplicado = PERCENTUAL_TOLERANCIA_PADRAO_RECOMENDADO_APLICADO;
        }

        if (!$scope.parametro.modelo_relatorio_visita) {
          $scope.parametro.modelo_relatorio_visita = MODELOS_RELATORIOS[0];
        } else {
          $scope.parametro.modelo_relatorio_visita = MODELOS_RELATORIOS.filter(function(modelo) {
            return modelo.id === $scope.parametro.modelo_relatorio_visita.id;
          })[0];
        }

        $scope.parametro.paginacao_envio = $scope.parametro.paginacao_envio || MAX_REGISTROS_ENVIO_PADRAO;

        $scope.setContratoValue(contrato.data);
      }, function(error) {
        MessagesService.alert('Ocorreu um erro ao recuperar parametrizações. Tenta novamente mais tarde.');
        console.error(`Erro parametrizações ${ JSON.stringify(error)}`);
      })
        .finally(LoadingService.hideLoading);
    }, $rootScope.errorRootInitialize);
  };

  $scope.saveParametro = function() {
    LoadingService.showLoading();
    ParametrosService.save($scope.parametro).then(function(parametro) {
      $scope.parametro = parametro.data.parametros;
      try {
        $scope.logomarcaUrl = SERVER + parametro.data.imagem.imagem_thumb_url;
      } catch (e) {
        console.error(e);
      }
      $rootScope.parametros = parametro.data.parametros;
      $scope.alert = REGISTRO_SALVO_COM_SUCESSO;
    }, function() {
      $scope.alert = FALHA_AO_SALVAR_REGISTRO;
    })
      .finally(function() {
        LoadingService.hideLoading();
        $location.hash('parametros-top');
        $anchorScroll();
      });
  };

  $scope.init();

  $scope.fileNameChanged = function() {
    const reader = new FileReader();
    reader.readAsDataURL($scope.parametro.logomarca);
    reader.onload = function(event) {
      const sizeKb = event.total / 1024;
      if (sizeKb > MAX_KBYTES_UPLOAD) {
        MessagesService.alert(`Arquivo muito grande! O arquivo pode ter no máximo ${ MAX_KBYTES_UPLOAD / 1024 }MB`);
      } else {
        $scope.parametro.logomarca = reader.result;
        $scope.$apply();
      }
    };
  };

  // eslint-disable-next-line complexity
  $scope.progressAreaContratada = function(attr) {
    let percent = $scope.contrato && $scope.contrato.area_maxima ?
      $scope.contrato.area_monitorada / $scope.contrato.area_maxima * 100 : 100;

    if (percent > 100) {
      percent = 100;
    }

    if (attr === 'style') {
      return {
        width: `${percent }%`
      };
    }
    if ($scope.contrato && !$scope.contrato.area_maxima) {
      return [
        'progress-bar-info',
        'progress-bar-striped',
        'active'
      ];
    }
    return {
      'progress-bar-info': percent <= 50,
      'progress-bar-warning': percent > 50 && percent <= 80,
      'progress-bar-danger': percent > 80
    };
  };

  $scope.setContratoValue = function(data) {
    $scope.contrato = data;
    $scope.contrato.modulos = $scope.contrato.modulos.sort(function(a, b) {
      return a.itens.length - b.itens.length;
    });
  };

  $scope.updateContrato = function() {
    LoadingService.showLoading();
    ContratoService.update().then(function(response) {
      $scope.setContratoValue(response.data);
    })
      .catch(function(response) {
        MessagesService.alert('Falha ao atualizar as informações do contrato');
        console.error('Falha ao atualizar contrato', response);
      })
      .finally(LoadingService.hideLoading);
  };

  $scope.testFormula = function() {
    LoadingService.showLoading();
    const keys = Object.keys(PrestacaoServicos.params);
    const paramsFormat = keys.map((key) => `${key} => ${PrestacaoServicos.params[key]}`);
    const paramsHtml = `<br><br> Parâmetros: <br><pre>${paramsFormat.join('<br>')}</pre>`;
    PrestacaoServicos.testFormula($scope.parametro.formula_centro_custos)
      .then((result) => {
        MessagesService.alert(`Resultado: <b>${result.data.id} - ${result.data.descricao}</b>. ${paramsHtml}`);
      })
      .catch((error) => {
        MessagesService.alert(`Falha ao executar a fórmula ${error.data}. ${paramsHtml}`);
      })
      .finally(LoadingService.hideLoading);
  };
});
